"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormDataApiCall = exports.createDeleteFileApiCall = exports.HEADER_KEY_PREFIX = void 0;
var uuid_1 = require("uuid");
var enviroment_vars_1 = require("../enviroment.vars");
var getExtension_1 = require("./getExtension");
exports.HEADER_KEY_PREFIX = 'x-amz-meta-';
function createDeleteFileApiCall(_a) {
    var bearer = _a.bearer, url = _a.url, _b = _a.authGuestToken, authGuestToken = _b === void 0 ? '' : _b;
    return __awaiter(this, void 0, void 0, function () {
        var headers, abortController, responseData, result, newBody, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    headers = {};
                    if (!authGuestToken) {
                        headers[exports.HEADER_KEY_PREFIX + "-token"] = bearer;
                        headers.Authorization = bearer;
                    }
                    if (authGuestToken) {
                        headers[exports.HEADER_KEY_PREFIX + "token"] = "" + authGuestToken;
                        headers.Authorization = "" + authGuestToken;
                    }
                    abortController = new AbortController();
                    return [4 /*yield*/, fetch(enviroment_vars_1.API_UPLOAD + "/" + url, {
                            headers: headers,
                            cache: 'no-cache',
                            method: 'DELETE',
                            signal: abortController ? abortController.signal : undefined,
                        })];
                case 1:
                    responseData = _c.sent();
                    if (responseData.status >= 300)
                        throw Error("Error code: " + responseData.status);
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, responseData.json()];
                case 3:
                    result = _c.sent();
                    newBody = __assign({}, (result || {}));
                    return [2 /*return*/, { body: newBody, status: responseData.status, abort: abortController.abort }];
                case 4:
                    e_1 = _c.sent();
                    return [2 /*return*/, { body: {}, status: responseData.status, abort: abortController.abort }];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.createDeleteFileApiCall = createDeleteFileApiCall;
function createFormDataApiCall(_a) {
    var bearer = _a.bearer, centralUserProfile = _a.centralUserProfile, _b = _a.url, url = _b === void 0 ? '' : _b, data = _a.data, _c = _a.authGuestToken, authGuestToken = _c === void 0 ? '' : _c, custom1 = _a.custom1, custom2 = _a.custom2, custom3 = _a.custom3, custom4 = _a.custom4, custom5 = _a.custom5;
    return __awaiter(this, void 0, void 0, function () {
        var headers, tenantId, uploadResponsibleEmail, uploadResponsibleUsername, ext, abortController, fileKey, responseData, result, newBody, e_2, newBody;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    headers = {};
                    if (!authGuestToken) {
                        headers[exports.HEADER_KEY_PREFIX + "-token"] = bearer;
                        headers.Authorization = bearer;
                    }
                    if (authGuestToken) {
                        headers[exports.HEADER_KEY_PREFIX + "token"] = "" + authGuestToken;
                        headers.Authorization = "" + authGuestToken;
                    }
                    tenantId = centralUserProfile.id;
                    uploadResponsibleEmail = centralUserProfile.email;
                    uploadResponsibleUsername = centralUserProfile.username;
                    /** basic types */
                    headers['Content-Type'] = data.file.type;
                    headers['Content-Length'] = "" + data.file.size;
                    headers[exports.HEADER_KEY_PREFIX + "filename"] = "" + data.file.name;
                    headers[exports.HEADER_KEY_PREFIX + "filetype"] = "" + data.file.type;
                    headers[exports.HEADER_KEY_PREFIX + "filesize"] = "" + data.file.size;
                    headers[exports.HEADER_KEY_PREFIX + "uploadResponsibleUsername"] = uploadResponsibleUsername;
                    headers[exports.HEADER_KEY_PREFIX + "uploadResponsibleEmail"] = uploadResponsibleEmail;
                    /** user types */
                    if (authGuestToken)
                        headers[exports.HEADER_KEY_PREFIX + "token"] = "" + authGuestToken;
                    if (tenantId)
                        headers[exports.HEADER_KEY_PREFIX + "tenantid"] = "" + tenantId;
                    if (centralUserProfile.uid)
                        headers[exports.HEADER_KEY_PREFIX + "userid"] = "" + centralUserProfile.uid;
                    /** custom types */
                    if (custom1)
                        headers[exports.HEADER_KEY_PREFIX + "custom1"] = "" + custom1;
                    if (custom2)
                        headers[exports.HEADER_KEY_PREFIX + "custom2"] = "" + custom2;
                    if (custom3)
                        headers[exports.HEADER_KEY_PREFIX + "custom3"] = "" + custom3;
                    if (custom4)
                        headers[exports.HEADER_KEY_PREFIX + "custom4"] = "" + custom4;
                    if (custom5)
                        headers[exports.HEADER_KEY_PREFIX + "custom5"] = "" + custom5;
                    ext = getExtension_1.getExtension(data.file.name);
                    abortController = new AbortController();
                    fileKey = "" + uuid_1.v4() + (ext ? "." + ext : '');
                    return [4 /*yield*/, fetch(enviroment_vars_1.API_UPLOAD + "/" + url + "/" + fileKey, {
                            body: data.binary,
                            headers: headers,
                            cache: 'no-cache',
                            method: 'POST',
                            signal: abortController ? abortController.signal : undefined,
                        })];
                case 1:
                    responseData = _d.sent();
                    if (responseData.status >= 300)
                        throw Error("Error code: " + responseData.status);
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, responseData.json()];
                case 3:
                    result = _d.sent();
                    newBody = __assign(__assign({}, (result || {})), { fileKey: fileKey });
                    return [2 /*return*/, { body: newBody, status: responseData.status, abort: abortController.abort }];
                case 4:
                    e_2 = _d.sent();
                    newBody = {
                        fileKey: fileKey,
                    };
                    return [2 /*return*/, { body: newBody, status: responseData.status, abort: abortController.abort }];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.createFormDataApiCall = createFormDataApiCall;
//# sourceMappingURL=createFormDataApiCall.js.map